import {
    closestCenter,
    type ClientRect,
    type CollisionDetection,
} from '@dnd-kit/core';

const verticalDistanceToPointer = (rect: ClientRect, pointerY: number) =>
    Math.max(rect.top - pointerY, 0, pointerY - rect.bottom);

// Prompt rows differ wildly in height once a section is expanded, and matching
// on rect centers makes a tall section count as the target only around its
// middle — aiming anywhere near its top edge lands on the prompt above it
// instead. The prompt the pointer sits level with is the one the drag is aiming
// at, so only the vertical axis decides: the drag handle hangs off the left of
// the row, which puts the pointer outside every row horizontally.
export const detectPromptGroupCollision: CollisionDetection = (args) => {
    const { droppableContainers, droppableRects, pointerCoordinates } = args;

    // Keyboard sorting moves without a pointer and derives its coordinates from
    // the rects themselves.
    if (!pointerCoordinates) {
        return closestCenter(args);
    }

    return droppableContainers
        .flatMap((droppableContainer) => {
            const rect = droppableRects.get(droppableContainer.id);
            if (!rect) {
                return [];
            }
            return {
                droppableContainer,
                distance: verticalDistanceToPointer(rect, pointerCoordinates.y),
            };
        })
        .sort((first, second) => first.distance - second.distance)
        .map(({ droppableContainer, distance }) => ({
            id: droppableContainer.id,
            data: { droppableContainer, value: distance },
        }));
};
